import { render, staticRenderFns } from "./HeatmapQuestion.vue?vue&type=template&id=f96b139e&scoped=true"
import script from "./HeatmapQuestion.vue?vue&type=script&lang=js"
export * from "./HeatmapQuestion.vue?vue&type=script&lang=js"
import style0 from "./HeatmapQuestion.vue?vue&type=style&index=0&id=f96b139e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96b139e",
  null
  
)

export default component.exports